"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCloseOnEsc = void 0;
var _react = require("react");
var useCloseOnEsc = exports.useCloseOnEsc = function useCloseOnEsc(props) {
  var escHandler = (0, _react.useCallback)(function (event) {
    if ((props === null || props === void 0 ? void 0 : props.open) && event.keyCode === 27) {
      props.setOpen(false);
    }
  }, [props]);
  (0, _react.useEffect)(function () {
    window.addEventListener('keydown', escHandler);
    return function () {
      return window.removeEventListener('keydown', escHandler);
    };
  }, [escHandler]);
};
//# sourceMappingURL=useCloseOnEsc.js.map